import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { CreateDocumentQueryAction } from 'reactApp/types/create-document-query-action';
import { openDisabledFeaturePopupHelper } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.helpers';
import { DisabledFeature } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.types';

const docFormatByAction = new Map<CreateDocumentQueryAction, string>()
    .set(CreateDocumentQueryAction.CREATE_DOCX, 'docx')
    .set(CreateDocumentQueryAction.CREATE_XLSX, 'xlsx');

export const goToNewDocumentIfCan = (state) => {
    const queryParams = SettingsSelectors.getQueryParams(state);
    const { isFull: isOverQuota } = UserSelectors.getCloudSpace(state);

    const queryAction = queryParams.action as CreateDocumentQueryAction | undefined;

    /* CLOUDWEB-14757: после принятия лицензии нужно открыть новый документ */
    if (queryAction && [CreateDocumentQueryAction.CREATE_DOCX, CreateDocumentQueryAction.CREATE_XLSX].includes(queryAction)) {
        if (isOverQuota) {
            return openDisabledFeaturePopupHelper({ disabledFeature: DisabledFeature.newFile });
        }

        const format = docFormatByAction.get(queryAction);

        if (format) {
            toolbarActions.create(format, 'external-link', false);
        }
    }
};
